import { render } from "./DescriptionProduct.vue?vue&type=template&id=3225939f&scoped=true"
import script from "./DescriptionProduct.vue?vue&type=script&lang=js"
export * from "./DescriptionProduct.vue?vue&type=script&lang=js"

import "./DescriptionProduct.vue?vue&type=style&index=0&id=3225939f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3225939f"]])

export default __exports__